import { render } from "./TypeOfPrinting.vue?vue&type=template&id=e5f049e4"
import script from "./TypeOfPrinting.vue?vue&type=script&lang=js"
export * from "./TypeOfPrinting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__